import { registerSync, Sync, File, Direction } from 'olympe';

/**
 * @extends {Sync}
 */
export class Email extends Sync {

    /**
     * @return {string}
     */
    getFrom() {
        return this.db.getProperty(this.tag, Email.fromProp);
    }

    /**
     * @return {string}
     */
    getTo() {
        return this.db.getProperty(this.tag, Email.toProp);
    }

    /**
     * @return {string}
     */
    getSubject() {
        return this.db.getProperty(this.tag, Email.subjectProp);
    }

    /**
     * @return {string}
     */
    getContent() {
        return this.db.getProperty(this.tag, Email.contentProp);
    }

    /**
     * @return {string}
     */
    isReceived() {
        return this.db.getProperty(this.tag, Email.receivedProp);
    }

    /**
     * @return {Array<File>}
     */
    getAttachments() {
        return this.db.getRelated(this.tag, Email.attachmentsRel).map(tag => /** @type File */ Sync.getInstance(tag));
    }
}

// Hardcoded tags
Email.entry = registerSync('0179d1b9aafdfa220a78', Email);
Email.fromProp = Email.entry.addProperty('0179d2081df76a00e793');
Email.toProp = Email.entry.addProperty('0179d1b9e577ee199c6b');
Email.subjectProp = Email.entry.addProperty('0179d1ba023cca957ebb');
Email.contentProp = Email.entry.addProperty('0179d1ba173eaa5a770c');
Email.receivedProp = Email.entry.addProperty('0179d2450b9a2fd60780');
Email.attachmentsRel = Email.entry.addRelation('0179d1ba5d577e4b0bb9');

